import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import { TASK_CREATE_REQUEST, TASK_CREATE } from 'store/constants/taskTypes';

// selectors
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

// schemas
import { taskSchema } from 'store/schemas/taskSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';

const WATCH_TYPE = TASK_CREATE_REQUEST;
const TYPE = TASK_CREATE;

export function* createTask(action: any) {
  const {
    payload: {
      formName,
      title,
      description,
      dueOn: due_on,
      leadIds: leads,
      accountIds: accounts,
    },
  } = action;

  const currentGroupId = yield select(getCurrentGroupId);

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.post, `/todos?group_id=${currentGroupId}`, {
      title,
      description,
      due_on,
      accounts,
      pnms: leads,
    }),
    {
      schema: taskSchema,
      formName,
    }
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, createTask);
}

export default function* root() {
  yield all([fork(watch)]);
}
